import React, { Component } from "react";

class AppLoader extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className="app-waiting">
        <div className="loading">
          <span>Xin chờ trong giây lát...</span>
        </div>
      </div>
    )
  }
}

export default AppLoader


// WEBPACK FOOTER //
// ./src/containers/Full/_AppLoader.js